import { Component } from '@verndale/core';
import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

class CardCarousel extends Component {
  setupDefaults() {
    this.dom = {
      sliderContainer: this.el.querySelector('.swiper-container'),
      prevBtn: this.el.querySelector('.swiper-button-prev'),
      nextBtn: this.el.querySelector('.swiper-button-next'),
      cards: this.el.querySelectorAll('.card-carousel__card'),
      controlsContainer: this.el.querySelector(
        '.card-carousel__controls-container'
      )
    };
    this.initSlider();
    this.setHeightOnCards();
  }

  setHeightOnCards() {
    const cardsArray = Array.from(this.dom.cards);
    if (cardsArray && cardsArray.length) {
      const heighestCard = Math.max(
        ...cardsArray.map(card => card.offsetHeight)
      );

      cardsArray.forEach(card => {
        card.style.height = `${heighestCard}px`;
      });
    }
  }

  initSlider() {
    const { sliderContainer, nextBtn, prevBtn, cards, controlsContainer } =
      this.dom;

    if (cards.length < 2) controlsContainer.style.display = 'none';

    const slider = new Swiper(sliderContainer, {
      // Default parameters
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      },
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 480px
        480: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 3,
          spaceBetween: 20
        }
      },
      on: {
        resize: swiper => {
          swiper.update();
        }
      }
    });
  }
}

export default CardCarousel;
